import { useEffect, useMemo } from 'react';

import { PAGE_TITLE } from '../../../constants/page';
import { useMainSelector } from '../../useMainSelector';

export const useChatNotificationsTitle = () => {
  const {
    chat: { notifications = [] },
  } = useMainSelector();

  const notificationCount = useMemo(
    () => notifications.length,
    [notifications.length],
  );

  useEffect(() => {
    const title =
      notificationCount === 0
        ? PAGE_TITLE
        : `(${notificationCount}) ${PAGE_TITLE}`;
    document.title = title;
  }, [notificationCount]);
};
